/* Oneberrie homepage (Oomira design): reviews carousel, films, 28-night
   calendar and the towel buy box. Respects reduced-motion settings. */
(() => {
  const calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const PLAY = 'M6 4l14 8-14 8z';
  const PAUSE = 'M6 4h4v16H6zM14 4h4v16h-4z';

  function initVoices(root) {
    $$('[data-voices]', root).forEach((voices) => {
      if (voices.dataset.ready) return;
      voices.dataset.ready = '1';
      const list = $$('.voice', voices);
      const out = $('[data-voice-n]', voices);
      if (!list.length) return;
      let at = 0;
      let auto = null;
      const go = (n) => {
        at = (n + list.length) % list.length;
        list.forEach((v, i) => v.classList.toggle('on', i === at));
        if (out) out.textContent = at + 1 + ' / ' + list.length;
      };
      const stop = () => {
        clearInterval(auto);
        auto = null;
      };
      const prev = $('[data-voice-prev]', voices);
      const next = $('[data-voice-next]', voices);
      prev && prev.addEventListener('click', () => (stop(), go(at - 1)));
      next && next.addEventListener('click', () => (stop(), go(at + 1)));
      if ('IntersectionObserver' in window && !calm && list.length > 1) {
        new IntersectionObserver(
          (es) => {
            if (es[0].isIntersecting) auto = auto || setInterval(() => go(at + 1), 6500);
            else stop();
          },
          { threshold: 0.3 }
        ).observe(voices);
      }
      go(0);
    });
  }

  function initFilms(root) {
    const films = $$('[data-film]', root);
    films.forEach((f) => {
      if (f.dataset.ready) return;
      f.dataset.ready = '1';
      const v = $('video', f);
      const b = $('button', f);
      if (!v || !b) return;
      const label = b.getAttribute('aria-label') || '';
      const sync = () => {
        const on = !v.paused;
        f.classList.toggle('playing', on);
        const p = $('path', b);
        p && p.setAttribute('d', on ? PAUSE : PLAY);
        b.setAttribute('aria-label', on ? label.replace('Play', 'Pause') : label);
      };
      const toggle = () => {
        if (v.paused) {
          $$('[data-film] video').forEach((o) => o !== v && o.pause());
          v.play().catch(() => {});
        } else v.pause();
      };
      b.addEventListener('click', toggle);
      v.addEventListener('click', toggle);
      v.addEventListener('play', sync);
      v.addEventListener('pause', sync);
    });
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (es) =>
          es.forEach((e) => {
            const v = e.target;
            if (e.isIntersecting) {
              if (v.hasAttribute('data-inview') && !calm) v.play().catch(() => {});
            } else v.pause();
          }),
        { threshold: 0.25 }
      );
      $$('[data-film] video, video[data-inview]', root).forEach((v) => io.observe(v));
    }
  }

  function initCalendars(root) {
    $$('[data-cal]', root).forEach((cal) => {
      if (cal.dataset.ready) return;
      cal.dataset.ready = '1';
      const host = cal.closest('[data-challenge]');
      let say = [];
      try {
        say = JSON.parse($('[data-cal-lines]', host).textContent)
          .map((l) => l.trim())
          .filter(Boolean);
      } catch (e) {}
      const last = host.dataset.calLast || '';
      const outN = $('[data-cal-n]', host);
      const outLine = $('[data-cal-line]', host);
      const label = host.dataset.calLabel || 'Night [n] of 28';
      const nights = $$('button', cal);
      let fill = null;
      const mark = (n) => {
        nights.forEach((b, i) => {
          b.classList.toggle('lit', i < n);
          b.classList.toggle('tonight', i === n - 1);
          b.setAttribute('aria-pressed', String(i === n - 1));
        });
        outN.textContent = label.replace('[n]', n);
        outLine.textContent = n === nights.length && last ? last : say[Math.min(say.length - 1, Math.floor((n - 1) / 7))] || '';
      };
      nights.forEach((b, i) => b.addEventListener('click', () => (clearInterval(fill), mark(i + 1))));
      if ('IntersectionObserver' in window && !calm) {
        mark(1);
        const io = new IntersectionObserver(
          (es) => {
            if (!es[0].isIntersecting) return;
            io.disconnect();
            let n = 1;
            fill = setInterval(() => {
              n += 1;
              mark(n);
              if (n >= nights.length) clearInterval(fill);
            }, 110);
          },
          { threshold: 0.5 }
        );
        io.observe(cal);
      } else mark(nights.length);
    });
  }

  function initBuy(root) {
    $$('[data-oo-buy]', root).forEach((box) => {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      let data;
      try {
        data = JSON.parse($('[data-oo-buy-json]', box).textContent);
      } catch (e) {
        return;
      }
      const form = $('form', box);
      const input = $('[name=id]', form);
      const submit = $('[type=submit]', form);
      const price = $('[data-buy-price]', box);
      const img = $('.buy-photo img', box);
      const error = $('[data-buy-error]', box);
      const pick = data.options.map((o, i) => {
        const first = data.variants.find((v) => v.id === data.selected) || data.variants[0];
        return first ? first.options[i] : o.values[0];
      });
      const find = (sel) => data.variants.find((v) => v.options.every((val, i) => val === sel[i]));
      const draw = () => {
        const v = find(pick);
        $$('[data-opt]', box).forEach((wrap) => {
          const i = Number(wrap.dataset.opt);
          $$('button', wrap).forEach((b) => {
            b.setAttribute('aria-pressed', String(b.dataset.val === pick[i]));
            const test = pick.slice();
            test[i] = b.dataset.val;
            const tv = find(test);
            b.toggleAttribute('data-out', !tv || !tv.available);
          });
          const say = $('[data-say="' + i + '"]', box);
          if (say) {
            // "Regular (< 28 inches)" reads as "Under 28 inches"; other values show as-is
            const m = pick[i].match(/\(\s*([<>])\s*([^)]*)\)/);
            say.textContent = m ? (m[1] === '<' ? 'Under ' : 'Over ') + m[2].trim() : wrap.classList.contains('prints') ? pick[i] : '';
          }
        });
        if (v) {
          input.value = v.id;
          price.textContent = v.price;
          if (v.image && img) {
            img.src = v.image;
            img.removeAttribute('srcset');
            img.alt = data.title + ', ' + v.title;
          }
          submit.disabled = !v.available;
          submit.textContent = v.available ? data.strings.add : data.strings.soldOut;
        } else {
          submit.disabled = true;
          submit.textContent = data.strings.unavailable;
        }
      };
      $$('[data-opt] button', box).forEach((b) =>
        b.addEventListener('click', () => {
          pick[Number(b.closest('[data-opt]').dataset.opt)] = b.dataset.val;
          draw();
        })
      );
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        if (submit.disabled) return;
        error.hidden = true;
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const body = { id: Number(input.value), quantity: 1 };
        if (cart && cart.getSectionsToRender) {
          body.sections = cart.getSectionsToRender().map((s) => s.id);
          body.sections_url = window.location.pathname;
        }
        submit.disabled = true;
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then((r) => r.json())
          .then((res) => {
            if (res.status) {
              error.textContent = res.description || res.message;
              error.hidden = false;
              return;
            }
            if (box.dataset.checkout === 'true') {
              window.location = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'checkout';
              return;
            }
            if (cart && cart.renderContents) {
              cart.classList.remove('is-empty');
              cart.renderContents(res);
            } else {
              window.location = window.routes ? window.routes.cart_url : '/cart';
            }
          })
          .catch(() => {
            error.textContent = data.strings.error;
            error.hidden = false;
          })
          .finally(() => draw());
      });
      draw();
    });
  }

  function init(root = document) {
    initVoices(root);
    initFilms(root);
    initCalendars(root);
    initBuy(root);
  }

  // While Shopify's cookie bar is open, mark the page so floating app buttons step aside.
  function watchConsentBar() {
    const html = document.documentElement;
    let seen = false;
    let ticks = 0;
    const check = () => {
      const bar = document.getElementById('shopify-pc__banner');
      const open = !!bar && bar.getClientRects().length > 0 && getComputedStyle(bar).visibility !== 'hidden';
      html.classList.toggle('oo-consent-open', open);
      if (open) seen = true;
      ticks += 1;
      // stop once the bar has been answered, or if it never appears within a minute
      if ((seen && !open) || (!seen && ticks > 60)) clearInterval(timer);
    };
    const timer = setInterval(check, 1000);
    check();
  }
  watchConsentBar();

  // Product pages on phones: a sticky "Add to cart" bar once the main button scrolls away.
  // It presses the real button, so variant choice, option apps and the cart drawer all behave as normal.
  function initStickyAtc() {
    const info = document.querySelector('product-info[id^="MainProduct-"], .product product-info');
    if (!info || document.querySelector('.oo-sticky-atc')) return;
    const submit = info.querySelector('product-form .product-form__submit, form[action*="/cart/add"] [type="submit"][name="add"]');
    if (!submit) return;
    const titleEl = info.querySelector('.product__title h1');
    const priceEl = info.querySelector('[id^="price-"] .price, .price');

    const bar = document.createElement('div');
    bar.className = 'oo-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="oo-sticky-atc__info"><span class="oo-sticky-atc__title"></span><span class="oo-sticky-atc__price"></span></div>' +
      '<button type="button" class="oo-sticky-atc__btn" tabindex="-1"></button>';
    document.body.appendChild(bar);
    const t = bar.querySelector('.oo-sticky-atc__title');
    const p = bar.querySelector('.oo-sticky-atc__price');
    const b = bar.querySelector('.oo-sticky-atc__btn');

    const sync = () => {
      t.textContent = titleEl ? titleEl.textContent.trim() : '';
      const shown = priceEl && (priceEl.querySelector('.price-item--sale:not(:empty)') || priceEl.querySelector('.price-item--regular'));
      p.textContent = shown ? shown.textContent.trim() : '';
      const label = submit.querySelector('span') || submit;
      b.textContent = label.textContent.trim();
      b.disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
    };
    sync();
    new MutationObserver(sync).observe(info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });

    b.addEventListener('click', () => {
      if (!b.disabled) submit.click();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        ([e]) => {
          const show = !e.isIntersecting && e.boundingClientRect.top < 0 && window.matchMedia('(max-width: 749px)').matches;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', String(!show));
          b.tabIndex = show ? 0 : -1;
          document.documentElement.classList.toggle('oo-sticky-open', show);
        },
        { threshold: 0 }
      ).observe(submit);
    }
  }

  // Product page upsells: live totals, option pickers, upgrade link that keeps the chosen print,
  // and add-ons added to the cart right after the main item (only when the main add succeeds).
  function formatMoney(cents, format) {
    const fmt = format || '${{amount}}';
    const n = (Number(cents) || 0) / 100;
    const two = n.toFixed(2);
    const swap = (s, sep, dec) => {
      const [a, b] = s.split('.');
      return a.replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (b ? dec + b : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return swap(Math.round(n).toString(), ',', '');
      if (k === 'amount_with_comma_separator') return swap(two, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return swap(Math.round(n).toString(), '.', '');
      return swap(two.endsWith('.00') ? n.toFixed(0) : two, ',', '.');
    });
  }

  function initUpsell() {
    const box = document.querySelector('[data-oo-upsell]');
    if (!box || box.dataset.ready) return;
    box.dataset.ready = '1';
    const info = box.closest('product-info') || document.querySelector('product-info');
    const fmt = box.dataset.moneyFormat;
    const summary = $('[data-oo-upsell-summary]', box);
    const error = $('[data-oo-upsell-error]', box);
    const items = $$('[data-oo-addon]', box);

    items.forEach((row) => {
      const check = $('[data-oo-addon-check]', row);
      const select = $('[data-oo-addon-select]', row);
      if (select) {
        select.addEventListener('change', () => {
          const opt = select.selectedOptions[0];
          check.value = opt.value;
          check.dataset.price = opt.dataset.price;
          $('[data-oo-addon-price]', row).textContent = (check.dataset.for ? '+' : '') + opt.dataset.priceText;
          const was = $('[data-oo-addon-was]', row);
          if (was) was.textContent = opt.dataset.wasText;
          if (!check.checked) check.checked = true;
          refreshSummary();
        });
      }
      check.addEventListener('change', refreshSummary);
    });

    function chosen() {
      return items.map((r) => $('[data-oo-addon-check]', r)).filter((c) => c.checked);
    }
    // "For" note on the cart line, naming the set with its chosen terry and print, so upgrades
    // and the beanie are matched to it
    function forProps(forText) {
      if (!forText) return {};
      const picked = $$('variant-selects input:checked, variant-selects select', info || document)
        .map((el) => el.value)
        .filter(Boolean)
        .join(' / ');
      return { properties: { For: picked ? forText + ' (' + picked + ')' : forText } };
    }
    function refreshSummary() {
      if (!summary) return;
      const list = chosen();
      const total = list.reduce((sum, c) => sum + Math.max(0, Number(c.dataset.price || 0) - Number(c.dataset.save || 0)), 0);
      summary.hidden = list.length === 0;
      summary.textContent = (box.dataset.adding || '')
        .replace('[n]', list.length)
        .replace('[price]', formatMoney(total, fmt));
    }

    // Upgrade card: same print/terry preselected, and the live price difference
    const upgrade = $('[data-oo-upgrade]', box);
    let upgradeVariants = [];
    try {
      upgradeVariants = JSON.parse($('[data-oo-upgrade-variants]', box).textContent);
    } catch (e) {}
    const productVariants = (() => {
      const s = info && info.querySelector('variant-selects script[type="application/json"], variant-radios script[type="application/json"]');
      try {
        return s ? JSON.parse(s.textContent) : [];
      } catch (e) {
        return [];
      }
    })();
    function refreshUpgrade() {
      if (!upgrade) return;
      const idInput = info && info.querySelector('form[action*="/cart/add"] input[name="id"]');
      const current = productVariants.find((v) => String(v.id) === String(idInput && idInput.value));
      const diffEl = $('[data-upgrade-diff]', upgrade);
      if (current) {
        const values = current.options.map((o) => String(o).toLowerCase());
        // best match: the set variant sharing the most option values (print and terry)
        let match = null;
        let best = 0;
        upgradeVariants.forEach((v) => {
          if (!v.available) return;
          const score = v.options.filter((o) => values.includes(String(o).toLowerCase())).length;
          if (score > best) {
            best = score;
            match = v;
          }
        });
        // the set comes with the plain, regular towel: keep the hood / large size the shopper chose
        const hood = Number(upgrade.dataset.hoodPrice || 0);
        const isLarge = values.some((o) => /large/.test(o));
        const large = isLarge ? Number(upgrade.dataset.largePrice || 0) : 0;
        const total = Number(upgrade.dataset.upgradePrice) + hood + large;
        // customers choose the hood / Large upgrade themselves on the set page (nothing is pre-ticked)
        upgrade.href = upgrade.dataset.upgradeUrl + (match ? '?variant=' + match.id : '');
        const totalEl = $('[data-upgrade-total]', upgrade);
        if (totalEl) {
          const notes = [hood ? upgrade.dataset.withHood : '', large ? upgrade.dataset.withLarge : ''].filter(Boolean).join(' + ');
          totalEl.textContent = formatMoney(total, fmt) + (notes ? ' ' + notes : '');
        }
        const diff = total - Number(current.price);
        if (diffEl) {
          diffEl.hidden = !(diff > 0);
          diffEl.textContent = diff > 0 ? '· ' + formatMoney(diff, fmt) + ' ' + (box.dataset.more || 'more') : '';
        }
      }
    }
    refreshUpgrade();
    if (info) info.addEventListener('change', () => setTimeout(refreshUpgrade, 60));

    // Swipeable extras: "+ Add" puts the item in the cart right away and refreshes the
    // cart drawer and cart count without opening the drawer.
    const showError = (msg) => {
      if (!error) return;
      error.textContent = msg || '';
      error.hidden = !msg;
    };
    $$('[data-oo-card]', box).forEach((card) => {
      const btn = $('[data-oo-card-add]', card);
      const select = $('[data-oo-card-select]', card);
      if (select) {
        select.addEventListener('change', () => {
          const opt = select.selectedOptions[0];
          btn.dataset.variant = opt.value;
          $('[data-oo-card-price]', card).textContent = opt.dataset.priceText;
          const was = $('[data-oo-card-was]', card);
          if (was) was.textContent = opt.dataset.wasText;
          btn.textContent = btn.dataset.label;
          btn.classList.remove('is-added');
        });
      }
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const sections = cart && cart.getSectionsToRender ? cart.getSectionsToRender() : [];
        btn.disabled = true;
        showError('');
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(btn.dataset.variant), quantity: 1, ...forProps(btn.dataset.for) }],
            sections: sections.map((s) => s.id),
            sections_url: window.location.pathname,
          }),
        })
          .then((r) => r.json())
          .then((res) => {
            if (res.status) return showError(res.description || res.message);
            // update the drawer and the cart count quietly (no pop-open)
            sections.forEach((section) => {
              const html = res.sections && res.sections[section.id];
              if (!html) return;
              const target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
              const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector || '.shopify-section');
              if (target && fresh) target.innerHTML = fresh.innerHTML;
            });
            if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            btn.textContent = btn.dataset.added;
            btn.classList.add('is-added');
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'oo-upsell', cartData: res });
            }
          })
          .catch(() => showError(' '))
          .finally(() => (btn.disabled = false));
      });
    });

    // Add checked extras right after a successful main add
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (!event || event.source !== 'product-form') return;
        const list = chosen();
        if (!list.length) return;
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const body = {
          items: list.map((c) => {
            const item = { id: Number(c.value), quantity: 1, ...forProps(c.dataset.for) };
            return item;
          }),
        };
        if (cart && cart.getSectionsToRender) {
          body.sections = cart.getSectionsToRender().map((s) => s.id);
          body.sections_url = window.location.pathname;
        }
        showError('');
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then((r) => r.json())
          .then((res) => {
            if (res.status) return showError(res.description || res.message);
            if (cart && cart.renderContents) cart.renderContents(res);
            list.forEach((c) => (c.checked = false));
            refreshSummary();
          })
          .catch(() => showError(' '));
      });
    }
  }

  // Product pages: move "Pickup available at…" out from under Add to cart into the
  // Delivery & Returns tab (or under the description). It keeps updating per variant.
  function movePickup() {
    const info = document.querySelector('product-info');
    const pickup = info && info.querySelector('pickup-availability');
    if (!pickup || pickup.dataset.ooMoved) return;
    const summaries = [...info.querySelectorAll('.product__accordion summary')];
    const delivery = summaries.find((s) => /delivery|shipping/i.test(s.textContent));
    const content = delivery && delivery.parentElement.querySelector('.accordion__content');
    const target = content || info.querySelector('.product__description');
    if (!target) return;
    pickup.dataset.ooMoved = '1';
    pickup.classList.add('oo-pickup');
    if (content) content.prepend(pickup);
    else target.after(pickup);
  }

  // Product pages: label the photo-swatch option "Print" and show the chosen print's name.
  function labelPrints() {
    const info = document.querySelector('product-info');
    if (!info) return;
    const update = () => {
      info.querySelectorAll('fieldset').forEach((fs) => {
        if (!fs.querySelector('label[style*="background-image"]')) return;
        const legend = fs.querySelector('legend');
        const checked = fs.querySelector('input[type="radio"]:checked');
        if (!legend) return;
        if (!legend.dataset.ooPrint) {
          legend.dataset.ooPrint = '1';
          legend.textContent = 'Print';
          legend.insertAdjacentHTML('beforeend', '<span class="oo-print-name"></span>');
        }
        const name = legend.querySelector('.oo-print-name');
        if (name) name.textContent = checked ? checked.value : '';
      });
    };
    update();
    info.addEventListener('change', () => setTimeout(update, 50));
    // the theme re-renders the options on variant change; re-apply when that happens
    new MutationObserver(() => {
      if ([...info.querySelectorAll('fieldset legend')].some((l) => !l.dataset.ooPrint && l.parentElement.querySelector('label[style*="background-image"]'))) update();
    }).observe(info, { childList: true, subtree: true });
  }

  // Shared reviews: turns the reviews saved on each product in the group into cards,
  // skipping entries with no real text (some only repeat the product name).
  function initSharedReviews() {
    document.querySelectorAll('[data-oo-revs]').forEach((sec) => {
      const rail = sec.querySelector('[data-oo-revs-rail]');
      if (!rail || rail.childElementCount) return;
      const max = parseInt(sec.dataset.max, 10) || 6;
      const forWord = sec.dataset.for || 'Reviewed:';
      const text = (el) => (el ? el.textContent.replace(/\s+/g, ' ').trim() : '');
      const esc = (t) => t.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
      const seen = new Set();
      const cards = [];
      sec.querySelectorAll('template[data-oo-rev-src]').forEach((tpl) => {
        tpl.content.querySelectorAll('.jdgm-rev').forEach((rev) => {
          const body = text(rev.querySelector('.jdgm-rev__body'));
          const named = (rev.dataset.productTitle || '').trim();
          if (body.length < 25 || body === named || seen.has(rev.dataset.reviewId)) return;
          seen.add(rev.dataset.reviewId);
          const rating = rev.querySelector('.jdgm-rev__rating');
          cards.push({
            score: (rating && parseInt(rating.dataset.score, 10)) || 5,
            head: text(rev.querySelector('.jdgm-rev__title')),
            body,
            author: text(rev.querySelector('.jdgm-rev__author')),
            title: tpl.dataset.title,
            url: tpl.dataset.url,
          });
        });
      });
      if (!cards.length) {
        sec.hidden = true;
        return;
      }
      rail.innerHTML = cards
        .slice(0, max)
        .map(
          (c) => `
        <figure class="oo-rev">
          <span class="oo-rating__stars" style="--oo-rating: ${c.score * 20}%;" role="img" aria-label="${c.score} out of 5"></span>
          ${c.head ? `<p class="oo-rev__head">${esc(c.head)}</p>` : ''}
          <blockquote class="oo-rev__body">${esc(c.body)}</blockquote>
          <figcaption class="oo-rev__by">${esc(c.author)}<a class="oo-rev__for" href="${c.url}">${esc(forWord)} ${esc(c.title)}</a></figcaption>
        </figure>`
        )
        .join('');
    });
  }

  // One short line under the size and fabric choices, for whichever option is selected
  // (product options stay as they are). Keys are matched against the option's value.
  const OPTION_NOTES = {
    'towel size': {
      regular: 'For babies under 28″ long. Towel is 30″ × 43″.',
      large: 'For babies 28″ long and up. Towel is 35″ × 50″.',
    },
    terry: {
      bamboo: 'Silky-soft, highly absorbent, for sensitive skin.',
      cotton: 'Pure, natural fibre: 100% organic cotton.',
    },
  };
  // A short tag beside an option's heading, e.g. TERRY  Knit in Canada
  const OPTION_TAGS = { terry: 'Knit in Canada' };
  function optionNotes() {
    const info = document.querySelector('product-info');
    if (!info) return;
    const update = () => {
      info.querySelectorAll('fieldset').forEach((fs) => {
        const legend = fs.querySelector('legend');
        const name = legend ? legend.firstChild.textContent.trim().toLowerCase() : '';
        if (OPTION_TAGS[name] && !legend.querySelector('.oo-legend-tag')) {
          legend.insertAdjacentHTML('beforeend', ` <span class="oo-legend-tag">${OPTION_TAGS[name]}</span>`);
        }
        const notes = OPTION_NOTES[name];
        if (!notes) return;
        const checked = fs.querySelector('input[type="radio"]:checked');
        const value = checked ? checked.value.toLowerCase() : '';
        const key = Object.keys(notes).find((k) => value.includes(k));
        let el = fs.querySelector('.oo-opt-note');
        if (!key) {
          if (el) el.remove();
          return;
        }
        if (!el) {
          el = document.createElement('p');
          el.className = 'oo-opt-note';
          el.setAttribute('aria-live', 'polite');
          fs.appendChild(el);
        }
        if (el.textContent !== notes[key]) el.textContent = notes[key];
      });
    };
    update();
    info.addEventListener('change', () => setTimeout(update, 50));
    new MutationObserver(() => {
      if ([...info.querySelectorAll('fieldset legend')].some((l) => OPTION_NOTES[l.firstChild.textContent.trim().toLowerCase()] && !l.parentElement.querySelector('.oo-opt-note'))) update();
    }).observe(info, { childList: true, subtree: true });
  }

  // Free-shipping progress in the cart drawer and cart page (threshold in the store's currency).
  // Canada only: the $100 CAD free-shipping rate is set for Canada; the USA and other zones have different rules.
  const FREE_SHIPPING = 100;
  function freeShipping() {
    if (!window.Shopify || Shopify.country !== 'CA') return;
    const rate = (window.Shopify && Shopify.currency && Number(Shopify.currency.rate)) || 1;
    const goal = Math.round(FREE_SHIPPING * rate * 100);
    const money = (cents) => (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD', minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 });
    let total = null;
    const paint = () => {
      if (total === null) return;
      const left = goal - total;
      const text = left > 0 ? `You’re <strong>${money(left)}</strong> away from free shipping.` : '<strong>You’ve got free shipping.</strong>';
      const pct = Math.max(0, Math.min(100, (total / goal) * 100));
      document.querySelectorAll('cart-drawer .drawer__header, #main-cart-items').forEach((anchor) => {
        let el = anchor.parentElement.querySelector(':scope > .oo-ship');
        if (!el) {
          el = document.createElement('div');
          el.className = 'oo-ship';
          el.setAttribute('role', 'status');
          anchor.insertAdjacentElement(anchor.id === 'main-cart-items' ? 'beforebegin' : 'afterend', el);
        }
        el.innerHTML = `${text}<div class="oo-ship__bar"><span style="width:${pct}%"></span></div>`;
        el.hidden = total === 0;
      });
    };
    const refresh = () =>
      fetch('/cart.js')
        .then((r) => r.json())
        .then((c) => {
          total = c.total_price;
          paint();
        })
        .catch(() => {});
    refresh();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(refresh, 300));
    const drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(() => { if (!drawer.querySelector('.oo-ship')) paint(); }).observe(drawer, { childList: true, subtree: true });
    document.addEventListener('change', (e) => { if (e.target.closest('cart-drawer, cart-items')) setTimeout(refresh, 900); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => (init(), initStickyAtc(), initUpsell(), movePickup(), labelPrints(), initSharedReviews(), optionNotes(), freeShipping()));
  else (init(), initStickyAtc(), initUpsell(), movePickup(), labelPrints(), initSharedReviews(), optionNotes(), freeShipping());
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
